import { useContext } from 'react';
import { ChatContext } from 'contexts/ChatContext';

const useChatContext = () => {
	const context = useContext(ChatContext);

	if (!context) throw new Error('useChatContext must be used within a ChatContextWrapper');

	return context;
};

export default useChatContext;
